<template>
  <div class=" is-fullwidth">
    <div class="field is-grouped mb-4">
      <div class="control">
        <label class="label" for="start-date-filter">Start Order Date</label>
        <input
          id="start-date-filter"
          class="input"
          type="date"
          v-model="start_date" :disabled="loading==true"
        >
      </div>
      <div class="control">
        <label class="label" for="makeup-location-filter">Makeup Location</label>
        <div class="select">
          <select id="makeup-location-filter" v-model="makeup_location_id" :disabled="loading==true">
            <option :value="null">All Locations</option>
           
            <option v-for="location in makeuplocations" :key="location.id" :value="location.id">
              {{ location.name }}
            </option>
             <option :value="9999">Location Not Set</option>
          </select>
        </div>
      </div>
      <div class="control" style="align-self: flex-end;">
        <button class="button is-primary" :class="{ 'is-loading': loading }" @click="getOrders">
          Reload
        </button>
      </div>
    </div>

    <div class="field mb-4">
      <label class="label" for="rep-name-filter">Sales Reps</label>
      <div class="control">
        <div class="select is-fullwidth">
          <select
            id="rep-name-filter"
            v-model="rep_to_add"
            :disabled="loading==true || availableRepOptions.length === 0"
            @change="addRepFilter"
          >
            <option :value="null">Select rep...</option>
            <option v-for="repName in availableRepOptions" :key="repName" :value="repName">
              {{ repName }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="selected_rep_names.length > 0" class="buttons mt-2">
        <button
          v-for="repName in selected_rep_names"
          :key="repName"
          type="button"
          class="button is-small is-info is-light"
          @click="toggleRepFilter(repName)"
        >
          {{ repName }}
        </button>
      </div>
    </div>

    <div class="field mb-4">
      <label class="label" for="region-filter">Regions</label>
      <div class="control">
        <div class="select is-fullwidth">
          <select
            id="region-filter"
            v-model="region_to_add"
            :disabled="loading==true || availableRegionOptions.length === 0"
            @change="addRegionFilter"
          >
            <option :value="null">Select region...</option>
            <option v-for="regionName in availableRegionOptions" :key="regionName" :value="regionName">
              {{ regionName }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="selected_region_names.length > 0" class="buttons mt-2">
        <button
          v-for="regionName in selected_region_names"
          :key="regionName"
          type="button"
          class="button is-small is-info is-light"
          @click="toggleRegionFilter(regionName)"
        >
          {{ regionName }}
        </button>
      </div>
    </div>

    <div v-if="loading" class="notification is-info is-light">
      Loading orders...
    </div>

    <div v-if="!loading && orders.length === 0" class="notification is-warning is-light">
      No orders found for the selected start date.
    </div>

    <div v-if="!loading && orders.length > 0 && filteredOrders.length === 0" class="notification is-warning is-light">
      No orders found for the selected filters.
    </div>
    
    <table v-if="filteredOrders.length > 0" class="is-size-7 table is-striped is-hoverable is-fullwidth">
      <thead>
        <tr>
          <th>Makeup Location</th>
          <th>PO Number</th>
          <th>Design Name</th>
          <th>Qty</th>
          <th>Client Name</th>
          <th>Region</th>
          <th>Order Date</th>
          <th>Delivery Date</th>
          <th>Artwork Completed</th>
          <th>Print Paper Complete</th>
          <th>Print Rolls Complete</th>
           <th>Gerber Cutting Complete</th>
          <th>Date Received In Makeup</th>
          <th>Date First On Floor</th>
          <th>Date All Off Floor</th>
          <th>Expected Turnaround Days</th>
          <th>Actual Turnaround Days</th>
          <th>Difference</th>
          <th>Days From Order Placed to Received In Makeup</th>
          <th>Days On/Off Floor</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in filteredOrders" :key="order.id">
          <td>{{ order.makeup_location_name }}</td>
        <td><a :href="'/orders/order-search?ponumber=' + order.ponumber" target="_blank">{{ order.ponumber }}</a></td>
          <td>{{ order.designname }}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{ order.clientname }}</td>
          <td>{{ order.locationName}}</td>
          <td>{{ order.orderdate }}</td>
          <td>{{ order.deliverydate }}</td>
          <td>{{ order.date_artwork_completed }}</td>
          <td>{{ order.date_printing_paper_completed }}</td>
          <td>{{ order.date_printing_rolls_completed }}</td>
          <td>{{ order.date_printing_gerber_completed }}</td>
          <td>{{ order.date_received_in_makeup }}</td>
          <td>{{ order.date_first_on_floor }}</td>
          <td>{{ order.date_all_off_floor }}</td>
          <td>{{ order.expected_turnaround_days }}</td>
          <td>{{ order.actual_turnaround_days }}</td>
          <td><span :class="{'has-text-danger': order.turnaround_difference < 0}" style="text-decoration:none">{{ order.turnaround_difference }}</span></td>
          <td>{{ order.orderdate_to_received }}</td>
          <td>{{ order.days_on_off_floor }}</td>
        </tr>
      </tbody>
    </table>

    
  </div>
</template>

<script>


//import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      selected_rep_names: [],
      rep_to_add: null,
      selected_region_names: [],
      region_to_add: null,
      loading: false,
      start_date: new Date(new Date().getTime() - 31 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
      accessToken: null,
      makeuplocations: [],
      makeup_location_id: null,
      ASP_SYSTEM_URL: process.env.VUE_APP_ASP_URL
    }
  },
   methods: {
    
      async getOrders() {
        this.loading = true;
        UtilityService.getSimpleApiData(this.accessToken, "orders/printing_throughput?start_date=" + this.start_date + "&makeup_location_id=" + this.makeup_location_id).then(
               response => {
                this.orders = response 
                const availableReps = new Set(this.orders
                  .map(order => (typeof order.rep_name === 'string' ? order.rep_name.trim() : ''))
                  .filter(repName => repName.length > 0));
                const availableRegions = new Set(this.orders
                  .map(order => (typeof order.locationName === 'string' ? order.locationName.trim() : ''))
                  .filter(regionName => regionName.length > 0));
                this.selected_rep_names = this.selected_rep_names.filter(repName => availableReps.has(repName));
                this.selected_region_names = this.selected_region_names.filter(regionName => availableRegions.has(regionName));
                this.loading = false;
               }
            );
      },
      toggleRepFilter(repName) {
        this.selected_rep_names = this.selected_rep_names.filter(name => name !== repName);
      },
      addRepFilter() {
        if (typeof this.rep_to_add === 'string' && this.rep_to_add.length > 0 && !this.selected_rep_names.includes(this.rep_to_add)) {
          this.selected_rep_names.push(this.rep_to_add);
        }
        this.rep_to_add = null;
      },
      toggleRegionFilter(regionName) {
        this.selected_region_names = this.selected_region_names.filter(name => name !== regionName);
      },
      addRegionFilter() {
        if (typeof this.region_to_add === 'string' && this.region_to_add.length > 0 && !this.selected_region_names.includes(this.region_to_add)) {
          this.selected_region_names.push(this.region_to_add);
        }
        this.region_to_add = null;
      },
     
    
  },
  computed : {
    repNameOptions() {
      return [...new Set(this.orders
        .map(order => order.rep_name)
        .filter(repName => typeof repName === 'string' && repName.trim().length > 0)
        .map(repName => repName.trim()))].sort((a, b) => a.localeCompare(b));
    },
    availableRepOptions() {
      return this.repNameOptions.filter(repName => !this.selected_rep_names.includes(repName));
    },
    regionNameOptions() {
      return [...new Set(this.orders
        .map(order => order.locationName)
        .filter(regionName => typeof regionName === 'string' && regionName.trim().length > 0)
        .map(regionName => regionName.trim()))].sort((a, b) => a.localeCompare(b));
    },
    availableRegionOptions() {
      return this.regionNameOptions.filter(regionName => !this.selected_region_names.includes(regionName));
    },
    filteredOrders() {
      return this.orders.filter(order => {
        const repName = typeof order.rep_name === 'string' ? order.rep_name.trim() : '';
        const regionName = typeof order.locationName === 'string' ? order.locationName.trim() : '';
        const matchesRep = this.selected_rep_names.length === 0 || this.selected_rep_names.includes(repName);
        const matchesRegion = this.selected_region_names.length === 0 || this.selected_region_names.includes(regionName);

        return matchesRep && matchesRegion;
      });
    }
    
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
          this.getMakeupLocations();
           
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

